<div class="container">

  <div class="row" hidden>
    <div class="col-sm-12">
      <a href="/api/gallery/document/{{document}}" class="btn btn-default">
        <!-- ng-href="/api/gallery/document/{{document}}" -->
        <i class="glyphicon glyphicon-save"></i> {{'Download' | translate}}
      </a>
      <span id="db-container"></span>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-12">
      <div *ngFor="let p in pages; index as i"
           class="d-inline-block d-text-center">
        <!-- abx-drop="movePageTo(i)" abx-drag="movePageFrom(i)" -->
        <a href="#/gallery/{{document}}/{{p}}?{{searchParam}}" *ngIf="token">
          <!-- ng-href="#!/gallery/{{document}}/{{p}}?{{searchParam}}" -->
          <img class="swrp-page" src="api/gallery/thumbnail/?document={{document}}&Page={{p}}" />
        </a><br />
            <a href="#/gallery/{{document}}/{{p}}" *ngIf="!token">
              <!-- ng-href="#!/gallery/{{document}}/{{p}}" -->
              <img class="swrp-page" src="api/gallery/thumbnail/?document={{document}}&Page={{p}}" />
            </a><br />
        <a href="javascript:void(0)" (click)="deletePageDialog(p, i)">{{'Delete' | translate}}</a>
      </div>
    </div>
  </div>

</div>
